// deps
import React, { useEffect, useRef, useContext, memo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import {
    AnalyticsEventContext,
    RouterContext,
    SwiggyHeadersContext,
} from "@swiggy-private/swiggy-money-context/src";
import lottie from "lottie-web/build/player/lottie_light";

// internal deps

// constants
import { GIFT_CARD_LOTTIE_URL, SM_MONEY_PATHS } from "../constants";

// hooks
import { useEffectOnce } from "../hooks/useEffectOnce";

// styles
import { StyledContainer } from "../styles";

interface GiftCardRedemptionProps {
    onLottieClose: VoidFunction;
    playLottie: boolean;
}

const GiftCardRedemption = ({ onLottieClose, playLottie }: GiftCardRedemptionProps) => {
    const lottieRef = useRef(null);
    const { router } = useContext(RouterContext);
    const { swiggyHeaders } = useContext(SwiggyHeadersContext);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { order_data = "" } = router.query;
    const { impressionEvent, impressionScreenViewLottie } = useContext(AnalyticsEventContext);

    useEffectOnce(() => {
        if (sessionStorage.getItem("giftcard-lottie-viewed")) {
            onLottieClose();
            return;
        }
    });

    useEffect(() => {
        if (!isEmpty(swiggyHeaders)) {
            impressionScreenViewLottie?.(impressionEvent);
        }
    }, [impressionEvent, impressionScreenViewLottie, swiggyHeaders]);

    useEffect(() => {
        if (lottieRef.current && playLottie) {
            const anim = lottie.loadAnimation({
                container: lottieRef.current,
                renderer: "svg",
                loop: false,
                autoplay: false,
                path: GIFT_CARD_LOTTIE_URL,
            });

            sessionStorage.setItem("giftcard-lottie-viewed", "true");
            anim.addEventListener("DOMLoaded", () => anim.play());
            anim.addEventListener("complete", () =>
                router.push(SM_MONEY_PATHS.GIFT_CLAIMING + "/?order_data=" + order_data)
            );
        }
    }, [order_data, playLottie, router]);

    return (
        <StyledContainer isGiftcardFlow>
            <div ref={lottieRef} />
        </StyledContainer>
    );
};

export default memo(GiftCardRedemption);
